<template>
  <div
    class="date-card"
    :class="{
      'date-card-active': !prev && !next,
      'date-card-inactive': prev || next,
      'date-card-today': isToday && (prev || next),
    }"
  >
    <div class="date-card-month">{{ month }}</div>
    <div class="date-card-date">{{ dayOfMonth }}</div>
    <div class="date-card-day">{{ dayOfWeek }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import moment from 'moment';

const props = defineProps({
  date: {
    type: Object,
    required: true,
  },
  prev: {
    type: Boolean,
    default: false,
  },
  next: {
    type: Boolean,
    default: false,
  },
});

const month = computed(() => props.date.format('MMM').toUpperCase());
const dayOfWeek = computed(() => props.date.format('ddd').toUpperCase());
const dayOfMonth = computed(() => props.date.format('D'));
const isToday = computed(() => props.date.isSame(moment(), 'day'));
</script>

<style scoped>
.date-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 10px;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 50px;
  max-width: 50px;
  height: 55px;
  font-weight: bold;
  margin: 0 2px;
}

.date-card-active {
  background-color: #ffc627;
  color: #000;
}

.date-card-inactive {
  background-color: #272727;
  color: #5b5b5b;
}

.date-card-inactive.date-card-today {
  border: 0.25px solid #ffc627;
  color: #d0d0d0;
}

.date-card-inactive:hover {
  background-color: #3a3a3a;
}

.date-card-month {
  font-size: 9px;
  line-height: 1.2;
}

.date-card-date {
  font-size: 16px;
  margin: 3px 0;
  line-height: 1;
}

.date-card-day {
  font-size: 9px;
  line-height: 1.2;
}
</style>
